/** biome-ignore-all lint/suspicious/noExplicitAny: Allowing any for flexibility as HTTP request could be anything */
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  EfpServiceUserNotificationService,
  INotification,
  NotificationType
} from '@ats/service-user-notification';
import { TranslocoService } from '@ngneat/transloco';
import { catchError, Observable, tap, throwError } from 'rxjs';

@Injectable()
export class ToastInterceptor implements HttpInterceptor {
  constructor(
    private userNotification: EfpServiceUserNotificationService,
    private translate: TranslocoService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const hasCustomSuccessMessage = req.headers.has('x-ats-success');
    const toastmessage =
      req.method === 'GET' || req.method === 'OPTIONS'
        ? null
        : req.headers.has('x-ats-suppress-message')
          ? null
          : hasCustomSuccessMessage
            ? decodeURIComponent(req.headers.get('x-ats-success') ?? '')
            : req.method === 'POST'
              ? this.translate.translate('Common.Create operation successful')
              : req.method === 'PATCH'
                ? this.translate.translate('Common.Update operation successful')
                : req.method === 'DELETE'
                  ? this.translate.translate('Common.Delete operation successful')
                  : this.translate.translate('Common.Operation successful');

    return next.handle(req).pipe(
      tap((resp) => {
        if (resp instanceof HttpResponse && toastmessage !== null) {
          this.showNotification({
            text: this.translate.translate('Common.Success') as string,
            message: toastmessage,
            type: NotificationType.Success
          });
        }
      }),
      catchError((error) => {
        if (!this.shouldSuppressErrorToast(req, error)) {
          this.showNotification({
            text: this.translate.translate('Common.Error') as string,
            message: this.translate.translate(
              'Common.There was an error performing this operation'
            ) as string,
            instruction: error.error?.detail,
            type: NotificationType.Error
          });
        }

        return throwError(() => error);
      })
    );
  }

  private showNotification(notification: INotification): void {
    setTimeout(() => {
      this.userNotification.show(notification);
    });
  }

  private shouldSuppressErrorToast(req: HttpRequest<any>, error: HttpErrorResponse): boolean {
    return req.url.includes('/people/api/personmetadata') && error.status === 409;
  }
}

@Injectable()
export class ToastEncodeInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let updatedRequest = req;
    const requestHeaders: Record<string, string> = {};

    if (req.headers.has('x-ats-success')) {
      requestHeaders['x-ats-success'] = encodeURIComponent(req.headers.get('x-ats-success') ?? '');
    }

    if (
      req.method === 'POST' &&
      req.url.toLowerCase().includes('/$query') &&
      !req.headers.has('x-ats-suppress-message')
    ) {
      requestHeaders['x-ats-suppress-message'] = '';
    }

    if (Object.keys(requestHeaders).length > 0) {
      updatedRequest = req.clone({
        setHeaders: requestHeaders
      });
    }

    return next.handle(updatedRequest);
  }
}

// @Injectable()
// export class ToastEncodeInterceptor implements HttpInterceptor {
//   constructor() {}

//   intercept(
//     req: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<unknown>> {
//     let updatedRequest = req;

//     if (req.headers.has('x-ats-success')) {
//       updatedRequest = req.clone({
//         headers: req.headers.set(
//           'x-ats-success',
//           encodeURIComponent(req.headers.get('x-ats-success') ?? '')
//         )
//       });
//     }

//     return next.handle(updatedRequest);
//   }
// }
